import e from "react";
import { X as g } from "lucide-react";
import { styled as h } from "@huspy/styled-system/jsx";
import { ItemPreviewImageOverlay as p } from "./ItemPreviewImageOverlay.mjs";
import "@ark-ui/react";
import { Flex as E } from "../../../components/box/index.mjs";
import "../../../components/button/button.mjs";
import "../../../components/checkbox/checkbox.mjs";
import { IconButton as x } from "../../../components/icon-button/icon-button.mjs";
import "../../../components/input/input.mjs";
import "../../../components/input/input-group.mjs";
import "../../../components/phone-input/phone-input.mjs";
import "../../../components/pin-input/pin-input.mjs";
import "../../../components/popover/popover.mjs";
import "../../../components/chip/chip.mjs";
import "../../../components/property-tag/property-tag.mjs";
import "../../../components/slider/slider.mjs";
import "../../../components/alert/alert.mjs";
import { Text as u } from "../../../components/typography/text.mjs";
import "../../../components/typography/title.mjs";
import "../../../components/menu/menu.mjs";
import "../../../components/progress/progress.mjs";
import "../../../components/date-picker/date-picker.mjs";
import "../../../components/tabs/tabs.mjs";
import "../../../components/collapsible/collapsible.mjs";
import "../../../components/dialog/dialog.mjs";
import "../../../components/radio/radio.mjs";
import "../../../components/radio-button/radio-button.mjs";
import { FileUpload as r } from "../../../components/file-upload/file-upload.mjs";
import "@dnd-kit/core";
import "@dnd-kit/sortable";
import "../../../components/table/table.mjs";
import "../../../components/pagination/pagination.mjs";
import "../../../components/combobox/combobox.mjs";
import "../../../components/select/select.mjs";
import "../../../components/badge/badge.mjs";
import "../../../components/property-chip/property-chip.mjs";
import "../../../components/number-input/number-input.mjs";
import "../../../components/switch/switch.mjs";
import "../../../components/toast/base.mjs";
import "../../../components/spinner/spinner.mjs";
import "../../../components/property-badge/property-badge.mjs";
import "../../../components/drawer/drawer.mjs";
import "../../../components/skeleton/skeleton.mjs";
import l from "../file-preview.png.mjs";
const m = h("img"), n = ({ numberOfHiddenPreviews: t }) => /* @__PURE__ */ e.createElement(
  E,
  {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    zIndex: "1",
    flexGrow: "1"
  },
  /* @__PURE__ */ e.createElement(u, { size: "md", fontWeight: "semibold", color: "text-white", textAlign: "center", lineHeight: "14px" }, t, " ", /* @__PURE__ */ e.createElement("br", null), " more")
), a = ({ src: t, filter: o }) => /* @__PURE__ */ e.createElement(r.ItemPreviewImage, { asChild: !0 }, /* @__PURE__ */ e.createElement(m, { width: "103px", height: "72px", objectFit: "cover", filter: o, src: t })), ae = ({
  numberOfHiddenPreviews: t = 0,
  size: o,
  id: c,
  ...s
}) => {
  const i = !!t;
  return /* @__PURE__ */ e.createElement(
    r.SortableItem,
    {
      display: "flex",
      position: "relative",
      width: "103px",
      height: "72px",
      padding: "0",
      border: "1px solid",
      borderColor: "border-secondary",
      borderRadius: "3",
      overflow: "hidden",
      onClick: (d) => {
        d.stopPropagation();
      },
      id: c,
      disableSorting: i,
      absoluteButtonPosition: !0,
      ...s
    },
    /* @__PURE__ */ e.createElement(r.ItemPreview, { type: "image/*" }, i ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(n, { numberOfHiddenPreviews: t }), /* @__PURE__ */ e.createElement(a, { filter: "brightness(0.2)" })) : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(p, { size: o }), /* @__PURE__ */ e.createElement(a, null))),
    /* @__PURE__ */ e.createElement(r.ItemPreview, { type: "^(?!image/.*$).*$" }, i ? /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(n, { numberOfHiddenPreviews: t }), /* @__PURE__ */ e.createElement(m, { src: l, width: "103px", height: "72px", objectFit: "cover" })) : /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(p, { size: o }), /* @__PURE__ */ e.createElement(m, { src: l, width: "103px", height: "72px", objectFit: "cover" }))),
    !i && /* @__PURE__ */ e.createElement(r.ItemDeleteTrigger, { asChild: !0 }, /* @__PURE__ */ e.createElement(
      x,
      {
        size: "sm",
        position: "absolute",
        top: "1",
        right: "1",
        minWidth: "unset",
        width: "18px",
        height: "18px",
        padding: "1"
      },
      /* @__PURE__ */ e.createElement(g, { color: "white" })
    ))
  );
};
export {
  ae as ImagesUploadItem
};
